{
  "version": 1,
  "asset_id": "14407e4e-e7df-439f-8880-79810791e271",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/14407e4e-e7df-439f-8880-79810791e271/svc-google-business-profile-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/14407e4e-e7df-439f-8880-79810791e271/svc-google-business-profile-640.webp",
  "original_filename": "svc-google-business-profile-640.webp",
  "size": 4282,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:50Z"
}
